import { Component, Renderer2, Inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LanguageService } from '@core/service/language.service';
import { DOCUMENT, CommonModule, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Sidebare2Component } from '../../pages/template/sidebare2/sidebare2.component';
import { TmwSidebarComponent } from '../../pages/template/tmw-sidebar/tmw-sidebar.component';
import { AppBreadcrumbComponent } from '../breadcrumb/app-breadcrumb.component';

@Component({
  standalone: true,
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss'],
  imports: [FooterComponent, RouterModule, TopbarComponent, SidebarComponent, NgxSpinnerModule, CommonModule, Sidebare2Component, TmwSidebarComponent, NgSwitch, NgSwitchCase, NgSwitchDefault, AppBreadcrumbComponent],
})
export class VerticalComponent {
  isCondensed = false;
  dataloader: any;
  isLoading: any;
  currentLang = 'fr';
  currentSidebar: string = 'default';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    // Subscribe to language changes and update the direction
    this.languageService.getCurrent().subscribe((lang) => {
      this.currentLang = lang;
      this.updatePageDirection();
    });

    // Subscribe to router events to handle sidebar changes and preloader
    this.router.events.subscribe((event: any) => {
      // Handle preloader
      if (document.documentElement.getAttribute('data-preloader') == 'enable') {
        if (event instanceof NavigationEnd) {
          // Update the attribute state based on the current route or any other conditions
          if (event.url !== '/disabled-route') {
            (document.getElementById('preloader') as HTMLElement).style.opacity = '1';
            (document.getElementById('preloader') as HTMLElement).style.visibility = '';
            setTimeout(() => {
              (document.getElementById('preloader') as HTMLElement).style.opacity = '0';
              (document.getElementById('preloader') as HTMLElement).style.visibility = 'hidden';
            }, 1000);
          } else {
            (document.getElementById('preloader') as HTMLElement).style.opacity = '0';
            (document.getElementById('preloader') as HTMLElement).style.visibility = 'hidden';
          }
        }
      }

      // Handle sidebar switching based on current route
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects || event.url;

        // Set the appropriate sidebar based on the current route
        if (currentUrl.includes('/template/sidebare2') || currentUrl.includes('sidebar2')) {
          this.currentSidebar = 'sidebar2';
        } else if (currentUrl.includes('/template/tmw-sidebar') || currentUrl.includes('tmw-sidebar')) {
          this.currentSidebar = 'tmw-sidebar';
        } else {
          this.currentSidebar = 'default';
        }

        console.log('Current route:', currentUrl, 'Current sidebar:', this.currentSidebar);
      }
    });

    window.addEventListener('resize', function () {
      if (document.documentElement.clientWidth <= 767) {
        document.documentElement.setAttribute('data-sidebar-size', '');
        document.querySelector('.hamburger-icon')?.classList.add('open');
      } else if (document.documentElement.clientWidth <= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
        document.querySelector('.hamburger-icon')?.classList.add('open');
        document.body.classList.remove('vertical-sidebar-enable');
      } else if (document.documentElement.clientWidth >= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
        document.querySelector('.hamburger-icon')?.classList.remove('open');
        document.body.classList.remove('vertical-sidebar-enable');
      }
    });
  }

  /**
   * Update the page direction based on the selected language
   */
  private updatePageDirection(): void {
    // Set the dir attribute on the HTML element
    this.renderer.setAttribute(this.document.documentElement, 'dir', this.currentLang === 'ar' ? 'rtl' : 'ltr');

    // Add data-layout attribute to trigger the RTL styles from the SCSS files
    if (this.currentLang === 'ar') {
      this.renderer.setAttribute(this.document.documentElement, 'data-layout-direction', 'rtl');
    } else {
      this.renderer.setAttribute(this.document.documentElement, 'data-layout-direction', 'ltr');
    }
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    const currentSIdebarSize = document.documentElement.getAttribute('data-sidebar-size');
    if (document.documentElement.clientWidth >= 767) {
      if (currentSIdebarSize == null) {
        document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == 'lg' ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
      } else if (currentSIdebarSize == 'md') {
        document.documentElement.getAttribute('data-sidebar-size') == 'md' ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md');
      } else {
        document.documentElement.getAttribute('data-sidebar-size') == 'sm' ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
    }

    if (document.documentElement.clientWidth <= 767) {
      document.body.classList.add('vertical-sidebar-enable');
    }
    this.isCondensed = !this.isCondensed;
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.querySelector('.custom-offcanvas')?.classList.toggle('show');
    document.getElementById('backdrop')?.classList.toggle('show');
    // document.body.classList.toggle('right-bar-enabled');
    // const rightBar = document.getElementById('theme-settings-offcanvas');
    // if (rightBar != null) {
    //   rightBar.classList.toggle('show');
    //   rightBar.setAttribute('style', "visibility: visible;");

    // }
  }
}
